import { render } from "./ServiceGridComp.vue?vue&type=template&id=5cb76d6e&scoped=true"
import script from "./ServiceGridComp.vue?vue&type=script&lang=js"
export * from "./ServiceGridComp.vue?vue&type=script&lang=js"

import "./ServiceGridComp.vue?vue&type=style&index=0&id=5cb76d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb76d6e"]])

export default __exports__